import * as React from 'react';
import { ClassroomsWidget } from './ClassroomsWidget';
import { CompletedPathwaysWidget } from './CompletedPathwaysWidget';
import { ScoresWidget } from './ScoresWidget';

export class LearnerProgressDashboard extends React.PureComponent {
    public render() {
        return (
            <div className='learner-progress-dashboard'>
                <div className='row'>
                    <div className='col-lg-6 col-md-12'>
                        <CompletedPathwaysWidget />
                    </div>
                    <div className='col-lg-6 col-md-12'>
                        <ScoresWidget />
                    </div>
                    <div className='col-12'>
                        <ClassroomsWidget />
                    </div>
                </div>
            </div>
        );
    }
}
